import { render, staticRenderFns } from "./EhrPatientTab.vue?vue&type=template&id=8ff6f548&scoped=true&lang=pug"
import script from "./EhrPatientTab.vue?vue&type=script&lang=js"
export * from "./EhrPatientTab.vue?vue&type=script&lang=js"
import style0 from "./EhrPatientTab.vue?vue&type=style&index=0&id=8ff6f548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff6f548",
  null
  
)

export default component.exports